import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import _ from 'lodash';

import {fetchClientAgenycTitles} from '../../actions/additional_actions';
import { formatPhoneInput } from '../../utils';

class ClientAgencyInfoForm extends React.Component {

    constructor(props) {
        super(props);

        this.clientAgencyFields = [
            'id', 'agencyName', 'firstName', 'lastName', 'titleId', 'preferredContactType', 'workPhone', 'mobilePhone', 'email'
          ];
      
          this.state = {
            ..._.pick(props.clientAgency, this.clientAgencyFields),
          }

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handlePreferredContactChange = this.handlePreferredContactChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTelChange = this.handleTelChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {    
        this.props.fetchClientAgenycTitles(this.props.projectId);
    }

    getTitleOptions() {
        return this.props.clientAgencyTitles.map(title => {
          return {
            label: title.title,
            value: title.id
          }
        });
      }

      handleTitleChange(option) {
        const titleId = option ? option.value : '';
        this.setState({ titleId });
      }

      handlePreferredContactChange(option) {
     
        const preferredContactType = option ? option.value : '';
        this.setState({ preferredContactType });
      }

      handleChange(field) {
        return (e) => {
          this.setState({ [field]: e.target.value });
        }
      }

      handleTelChange (field) {
          return (e) => {
            let tel = e.target.value;
            tel = tel.replace(/\D/g, '').substring(0, 10); 
            this.setState({ [field]: tel });
          }
      }

      handleSubmit(e) {
        e.preventDefault();

        const clientAgency = _.pick(this.state, this.clientAgencyFields);
        this.props.onSave(clientAgency);
      }

    render() {
        const {agencyName, firstName, lastName, titleId, preferredContactType, email, workPhone, mobilePhone} = this.state;
        let canSubmit = false; 

          canSubmit = (agencyName!==undefined && agencyName!=='') && (firstName!==undefined && firstName!=='') && (lastName!==undefined && lastName!=='') 
           && (titleId > 0) && (preferredContactType!==undefined && preferredContactType!=='')&& (email!==undefined && email!=='')
           && (preferredContactType === 'Work Phone' ? (workPhone!==undefined && workPhone!=='') : (mobilePhone!==undefined && mobilePhone!=='')) ;
    
        return (
            <form className="modal-form blue-book-form" onSubmit={this.handleSubmit}>

                <div className="control required">
                    <label>Sponsor Agency Name</label>
                    <input type="text" name="agencyName"
                        value = {this.state.agencyName}
                        onChange = {this.handleChange('agencyName')}
                    />
                </div>

                <div className="member-details two-cols">
                    <div className="control required">
                        <label>First Name</label>
                        <input type="text" name="firstName"
                            value = {this.state.firstName}
                            onChange = {this.handleChange('firstName')}
                        />
                    </div>

                    <div className="control required">
                        <label>Last Name</label>
                        <input type="text" name="lastName"
                            value = {this.state.lastName}
                            onChange = {this.handleChange('lastName')}
                        />
                    </div>
                </div>

                <div className="control required">
                    <label>Title</label>
                    <Select name=""
                        value={this.state.titleId}
                        options={this.getTitleOptions()}
                        onChange={this.handleTitleChange}
                    />
                </div>

                <div className="member-details two-cols">
                    <div className="control required">
                        <label>Email</label>
                        <input type="email" name="email"
                            value={this.state.email}
                            onChange={this.handleChange('email')}
                        />
                    </div>

                    <div className="control required">
                        <label>Preferred Contact Type</label>
                        <Select
                            name="form-field-name"
                            value={this.state.preferredContactType}
                            options={[
                                { value: 'Work Phone', label: 'Work Phone' },
                                { value: 'Mobile Phone', label: 'Mobile Phone' },
                            ]}
                            onChange={this.handlePreferredContactChange}
                        />
                    </div>
                </div>

                <div className="member-details two-cols">
                    <div className={'control' + (this.state.preferredContactType === 'Work Phone' ? ' required' : '')}>
                        <label>Work Phone</label>
                        <input type="tel" name="workPhone" 
                            value={formatPhoneInput(this.state.workPhone)}
                            onChange={this.handleTelChange('workPhone')}
                        />
                    </div>          

                    <div className={'control' + (this.state.preferredContactType === 'Mobile Phone' ? ' required' : '')}>
                        <label>Mobile Phone</label>
                        <input type="tel" name="mobilePhone" 
                            value={formatPhoneInput(this.state.mobilePhone)}
                            onChange={this.handleTelChange('mobilePhone')}
                        />
                    </div>
                </div>

                <button className="btn-update"  disabled={!canSubmit}>
                    Save
        </button>
            </form>
        )
    }
}

ClientAgencyInfoForm.propTypes = {
    clientAgency: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        clientAgencyTitles: state.additionalProjectsStore.clientAgencyTitles,
    };
}
  
export default connect(mapStateToProps, {fetchClientAgenycTitles}) (ClientAgencyInfoForm);